export default __webpack_public_path__ + "static/media/jul2.9aaaf66a.jpg";